module.exports = __webpack_public_path__ + "img/2025big20.312b79b3.jpg";